import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getCMSClientList } from '../../helpers/fetchCmsContent';
import IconsSlider from '../../IconsSlider';


const API_URL = process.env.REACT_APP_CMS;

export default function ClientsSlider({ t }) {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const fetchClients = async () => {
            const clientsList = await getCMSClientList();
            setClients(clientsList);
        };
        fetchClients();
    }, []);

    return (
        <div className="clients-container">
            <div className="layout">
                <div className="clients-title" id="section-title-legal-notice">
                    <h2 dangerouslySetInnerHTML={ { __html: t('offer.clients.title') } }/>
                </div>
                <IconsSlider
                  className="clients-slider"
                  loader
                  items={ clients.map((client) => ({
          imgUrl: `${ API_URL }/assets/${ client.logo.id }`,
          title: client.name,
          id: client.id,
          url: client.url
        })) }
                />
            </div>
        </div>
    );
}

ClientsSlider.propTypes = {
    t: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/content/offer/ClientsSlider.jsx